import { HelpTooltip } from '../../shared/components';
import styled from 'styled-components';
import { Radio } from 'antd';
import { useSelector } from 'react-redux';
import selectors from '../../redux/selectors/selectors';

const Title = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const HelpIcon = styled.div`
  margin-left: 4px;
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  width: 100%;
  margin-top: -8px;
`;

const StyledRadioButton = styled(Radio.Button)`
  display: flex;
  width: 100%;
  justify-content: center;
  text-align: center;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  background-color: #022973;
  border: solid 2px #06abc1;
  position: relative;
  margin-right: 0;

  &:hover {
    background: #003fb6;
    color: white;
  }

  &.ant-radio-button-wrapper-checked {
    background-color: #011741;
    z-index: 1;

    &:hover {
      background-color: #011741;
    }
  }

  &:first-child {
    border-radius: 5px 0 0 5px;
    border-inline-start: solid 2px #06abc1;
  }

  &:last-child {
    border-radius: 0 5px 5px 0;
  }

  &:not(:first-child) {
    margin-left: -1px;
  }

  /* Override Ant Design's border style */

  &.ant-radio-button-wrapper:not(:first-child)::before {
    display: none;
  }
`;

export function MinRegionCheck({ setValue, value, setShowFreeTierUpgrade }) {
  const isFreeTier = useSelector(selectors.isFreeTier);
  const handleChange = (e) => {
    if (isFreeTier && e.target.value > 1) {
      setValue(1);
      setShowFreeTierUpgrade(true);
    } else {
      setValue(e.target.value);
    }
  };
  return (
    <div style={{ marginBottom: '10px' }}>
      <Title>
        <h4>Minimum Healthy Locations</h4>
        <HelpIcon>
          <HelpTooltip
            text="The minimum number of healthy locations reporting in before your site is considered online/offline.
                    Must be greater than or equal to the number of selected Locations."
          />
        </HelpIcon>
      </Title>

      <StyledRadioGroup
        value={value}
        onChange={handleChange}
        buttonStyle="solid"
        optionType="button">
        {[1, 2, 3].map((num) => (
          <StyledRadioButton
            key={num}
            value={num}>
            {num}
          </StyledRadioButton>
        ))}
      </StyledRadioGroup>
    </div>
  );
}
